import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['inner', 'header', 'main', 'footer']

  connect() {
    // this.innerTarget.classList.add('-hide')
  }

  loaded() {
    this.innerTarget.classList.remove('-hide')
  }
}